// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetProjectByIdRequestModel from '../../model/get-project-by-id-request-model';
import GetProjectByIdRequestDTO from '../dto/get-project-by-id-request-dto';
import dtoSchema from '../schemas/get-project-by-id-request-schema';

export default abstract class GetProjectByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetProjectByIdRequestDTO>) {
    super();
    if (data) {
      this.projectId = data.projectId;
    }
  }
  /**
  * @type {uuid}
  */
  projectId?: string;

  static toModel(dto: DeepPartial<GetProjectByIdRequestDTO>): GetProjectByIdRequestModel;
  static toModel(dto: DeepPartial<GetProjectByIdRequestDTO> | undefined | null): GetProjectByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetProjectByIdRequestDTO> | undefined | null): GetProjectByIdRequestModel | undefined {
    return dto ? new GetProjectByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetProjectByIdRequestModel> | GetProjectByIdRequestModel): GetProjectByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      projectId: unwrapped.projectId,
    } as GetProjectByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetProjectByIdRequestModel, can not map to GetProjectByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
